import { forwardRef } from 'react';
/**
 * Same as `forwardRef` except it returns the type of `component`.
 *
 * @param component Component to `forwardRef`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withRef = (component) => forwardRef(component);
//# sourceMappingURL=withRef.js.map